import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Unified Auth Context
 *
 * This context provides a consistent auth interface regardless of whether
 * we're using real Descope auth or mock auth for development.
 *
 * Components should use useAuthSession(), useAuthUser(), and useAuthActions()
 * from this module instead of importing directly from Descope.
 */
import { createContext, useContext } from "react";
const AuthContext = createContext(null);
export function AuthContextProvider({ children, value, }) {
    return _jsx(AuthContext.Provider, { value: value, children: children });
}
function useAuthContext() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuthContext must be used within an AuthProvider");
    }
    return context;
}
/**
 * Hook to get session state (authenticated, loading)
 */
export function useAuthSession() {
    return useAuthContext().session;
}
/**
 * Hook to get user data
 */
export function useAuthUser() {
    return useAuthContext().userState;
}
/**
 * Hook to get auth actions (logout, etc.)
 */
export function useAuthActions() {
    return useAuthContext().actions;
}
//# sourceMappingURL=auth-context.js.map